import { get, post } from "@/utils/http";

let baseURL = "/charge";
/**
 * 获取列表
 */
const getChargeList = data => post(`${baseURL}/queryInfo`, { data });

/**
 * 导出
 */
const exportExcel = data => post(`${baseURL}/exportExcel`, { data, responseType :'blob'});

export default {
  getChargeList,
  exportExcel
};
